export default __webpack_public_path__ + "static/media/member2.9308634a.jpg";